export default "__VITE_ASSET__Bi$aB9MV__"